import classNames from 'classnames';
import React__default, { useState, useRef, useEffect } from 'react';
import { s as styleInject } from './style-inject.es-746bb8ed.js';

var css_248z = ".RM2r1,.glob_fontElementMap{font-family:var(--ricos-font-family,unset)}.hoDa3{width:100%}.w-vOl{display:flex;font-size:16px;height:50px;justify-content:space-evenly;line-height:1.5}[dir] .w-vOl{border-bottom:1px solid #ededed;cursor:pointer}.M-qB3{font-size:16px;font-weight:300;width:100%}[dir] .M-qB3{background-color:transparent;border:none;border-bottom:3px solid transparent;cursor:pointer;text-align:center}.M-qB3:hover:not(._5DMyj){opacity:.5}[dir] .M-qB3:hover:not(._5DMyj){border-bottom:3px solid var(--ricos-settings-text-color,#000)}.M-qB3:hover:not(._5DMyj) .xQo7X{color:#000}[dir] ._5DMyj{border-bottom:3px solid var(--ricos-settings-action-color,var(--ricos-action-color-fallback,#116dff))}.xQo7X{color:var(--ricos-settings-text-color,#000);font-family:var(--ricos-settings-text-font-family,Helvetica Neue,Helvetica,Arial)}[dir] .xQo7X{cursor:pointer}";
var styles = {"fontElementMap":"RM2r1","tabs":"hoDa3","tabs_headers":"w-vOl","tabs_headers_option":"M-qB3","tabs_headers_option_selected":"_5DMyj","tabs_headers_option_label":"xQo7X"};
styleInject(css_248z);

const TabsHeader = ({
  label,
  value,
  isSelected,
  onClick,
  focused,
  onKeyDown,
  focusIndex,
  className
}) => {
  const [tabIndex, setTabIndex] = useState(isSelected ? 0 : focusIndex);
  const headerRef = useRef(null);
  const onBlur = () => isSelected ? setTabIndex(0) : setTabIndex(-1);
  useEffect(() => {
    var _a;
    if (focused) {
      (_a = headerRef == null ? void 0 : headerRef.current) == null ? void 0 : _a.focus();
    } else {
      !isSelected && setTabIndex(-1);
    }
  }, [focusIndex, isSelected]);
  return /* @__PURE__ */ React__default.createElement(
    "button",
    {
      id: `${value}_header`,
      role: "tab",
      tabIndex,
      name: `tabs`,
      key: value,
      onBlur,
      onKeyDown,
      ref: headerRef,
      className: classNames(styles.tabs_headers_option, {
        [styles.tabs_headers_option_selected]: isSelected
      }),
      "data-hook": `${value}_Tab`,
      "aria-controls": `${value}_panel`,
      "aria-label": value,
      "aria-selected": isSelected,
      onClick,
      type: "button"
    },
    /* @__PURE__ */ React__default.createElement("span", { className: classNames(styles.tabs_headers_option_label, className) }, label)
  );
};

export { TabsHeader as T, styles as s };
//# sourceMappingURL=TabsHeader-b0caafc5.js.map
